module.exports = __webpack_public_path__ + "static/media/CloudUpload.f80f86b6.svg";